import { queryOptions } from "@tanstack/react-query";

import { startEarly, takeEarly } from "@/utils/earlyRequest";
import casinoService from "../services/casinoService";

export const startCasinoData = (promoId: string) =>
  startEarly(`casinoData:${promoId}`, () => casinoService.getCasinoData(promoId));

export const casinoDataQuery = (promoId: string) =>
  queryOptions({
    queryKey: ["casinoData", promoId],
    queryFn: () => takeEarly(`casinoData:${promoId}`, () => casinoService.getCasinoData(promoId)),
  });
